import PropTypes from "prop-types";

// Material UI Components
import Select from "react-select";
import Typography from "@mui/material/Typography";

// bucket definitions A1-A8
import { BUCKET_DATA, BUCKET_OPTIONS, DEFAULT_BUCKET } from "../../utils/fragranceBucketData";

function FragranceDriverTab({ selectedBucket = null, setSelectedBucket = () => { } }) {
    // Bucket options A1 to A8 (from shared definitions)
    const bucketOptions = BUCKET_OPTIONS;

    // Currently selected bucket (fall back to A1 when nothing is selected yet)
    const currentBucket = BUCKET_DATA.find((bucket) => bucket.id === (selectedBucket?.value || DEFAULT_BUCKET.id)) || DEFAULT_BUCKET;

    return (
        <div
            className="card-btns"
            style={{
                padding: "0px 0px",
                margin: "10px 0px",
                marginTop: "30px",
                marginRight: "60px",
            }}
        >

            <div
                className="d-flex fragrance-driver-tab-fields"
                style={{
                    alignItems: "center",
                    gap: "15px",
                    flexWrap: "wrap",
            }}
        >
            {/* Bucket dropdown (active placeholder) */}
            <div
                className="d-flex"
                style={{ alignItems: "center" }}
            >
                <Typography
                    className="color-blue"
                    sx={{
                        fontSize: "12px",
                        fontWeight: "700",
                        marginRight: "5px",
                        whiteSpace: "nowrap",
                    }}
                >
                    Bucket:
                </Typography>
                    <div className="dropdown-card-dropdown-container "
                    style={{
                            width: "120px",
                            minWidth: "90px",
                        }}
                        >
                        <Select
                            className="dropdown dropdown-first-row "
                            name={"bucket"}
                            placeholder={"Bucket"}
                            isSearchable={true}
                            onChange={(newValue) => setSelectedBucket(newValue)}
                            value={{ value: currentBucket.id, label: currentBucket.id }}
                            options={bucketOptions}
                        />
                    </div>
                </div>

                {/* Target Variable (read-only, auto-mapped from the selected bucket) */}
                <div
                    className="d-flex"
                    style={{
                        alignItems: "center",
                    }}
                >
                <Typography
                    className="color-blue"
                    sx={{
                        fontSize: "12px",
                        fontWeight: "700",
                        marginRight: "5px",
                        whiteSpace: "nowrap",
                    }}
                >
                    Target Variable:
                </Typography>
                    <div className="dropdown-card-dropdown-container "
                    style={{
                            width: "280px",
                            minWidth: "180px",
                            fontSize: "14px",
                        }}
                        >
                        <Select
                            className="dropdown dropdown-first-row "
                            name={"targetVariable"}
                            placeholder={"Target Variable"}
                            isDisabled={true}
                            value={{ value: currentBucket.target_kpi, label: currentBucket.target_kpi_label }}
                            options={[{ value: currentBucket.target_kpi, label: currentBucket.target_kpi_label }]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

// Typechecking props for the FragranceDriverTab
FragranceDriverTab.propTypes = {
    selectedBucket: PropTypes.object,
    setSelectedBucket: PropTypes.func,
};

export default FragranceDriverTab;
